import {
    Box,
    Button,
    Grid
} from "@mui/material";
import { IconPencil, IconPlus, IconTrash } from "@tabler/icons";
import React, { useContext, useEffect, useState } from "react";

import CustomDataTable from "../../../components/DataTable";
import { MainContext } from "../../../state/state";

import openDeleteModal from "src/helpers/deleteHandler";
import handleError from "src/helpers/errorHandler";
import { LiveDetail, LiveStage } from "src/types/live";
import sendRequest from "../../../helpers/service";
import StageModal from "./StageModal";
import { Image } from "@mui/icons-material";

const tableOptions = {
  actionStatus: true,
  selectedRow: false,
  isSelected: false,
  title: "Stages",
  tableHeadItems: [
    {
      name: "ID",
      key: "id",
      align: "left",
    },
    {
      name: "Thumbnail",
      key: "thumbnail",
      align: "left",
    },
    {
      name: "Name",
      key: "title",
      align: "left",
    },
  ],
};

interface StagesTabProps {
  permission: any;
  detail: LiveDetail;
  setDetail: React.Dispatch<React.SetStateAction<any>>;
}

export default function StagesTab({ permission, detail, setDetail }: StagesTabProps) {
  const { setLoading } = useContext(MainContext);

  const [stages, setStages] = useState([]);
  const [editingStage, setEditingStage] = useState<any>(null);

  const [stageModal, setStageModal] = useState<"new" | LiveStage>();

  useEffect(() => {
    fetchStages();
  }, []);

  const fetchStages = async () => {
    try {
      const res = await sendRequest.get({ url: `live/stage/${detail.id}` });
      setStages(res.data || []);
    } catch (error) {
      handleError(error);
    }
  };

  const handleDelete = (stageId: number) => {
    openDeleteModal({
      apiUrl: `live/stage/${stageId}`,
      successText: "Stage deleted successfully",
      modals: [
        {
          title: "Delete Stage",
          message: `Are you sure to delete this stage?`,
          cancelButton: {
            text: "Cancel",
          },
          confirmButton: {
            text: "Delete",
          },
        },
      ],
    }).finally(() => {
      fetchStages();
    });
  };

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        mb={2}
        textAlign={"end"}
      >
        <Button
          variant="contained"
          color="success"
          startIcon={<IconPlus />}
          onClick={() => setStageModal("new")}
          disabled={!permission?.live?.write}
        >
          Add New Stage
        </Button>
      </Grid>

      <Grid
        item
        xs={12}
      >
        <CustomDataTable
          tableOptions={tableOptions}
          rows={stages}
          page={0}
          emptyStateText="There is no stage"
          rowsPerPage={stages.length}
          totalCount={stages.length}
          error={false}
          loading={false}
          ActionChildren={(props) => (
            <Box sx={{ minWidth: "150px" }}>
              <Button
                variant="contained"
                size="small"
                sx={{ mr: 1 }}
                onClick={() => setStageModal(props.row)}
                disabled={!permission?.live?.write}
              >
                <IconPencil size={"1.1rem"} />
              </Button>
              <Button
                variant="contained"
                size="small"
                color="error"
                onClick={() => handleDelete(props.row.id)}
                disabled={!permission?.live?.delete}
              >
                <IconTrash size={"1.1rem"} />
              </Button>
            </Box>
          )}
        >
          {{
            id: ({ row }) => <div>{row.id}</div>,
            thumbnail: ({ row }) => {
              if (row.thumbnail) {
                return (
                  <img
                    style={{ width: 60, height: 40, objectFit: "cover" }}
                    className="thumbnail"
                    alt=""
                    src={row.thumbnail}
                  />
                );
              } else {
                return <Image style={{ color: "lightgray" }} />;
              }
            },
          }}
        </CustomDataTable>
      </Grid>
      {stageModal && (
        <StageModal
          stage={stageModal}
          live_id={detail.id}
          onClose={() => setStageModal(undefined)}
          onSave={fetchStages}
          onUpdate={fetchStages}
        />
      )}
    </Grid>
  );
}
